import axios from 'axios';
import https from 'https';

const httpsAgent = new https.Agent({
	rejectUnauthorized: false,
});
const instance = axios.create({
	baseURL: `${process.env.VUE_APP_APIURL}/api`,
	httpsAgent,
});

export default {
	namespaced: true,
	state: {},
	actions: {
		async verifyReferralCode(context, status) {
			const api = `/airlee/mgm/verify_referral_code`;
			context.commit('LOADING', true, { root: true });
			try {
				const res = await instance({
					method: 'post',
					url: api,
					data: status,
				});
				context.commit('LOADING', false, { root: true });
				if (res.data.status === 'success') {
					return res.data;
				} else {
					throw new Error(res.data.message);
				}
			} catch (err) {
				context.commit('LOADING', false, { root: true });
				if (err.response && err.response.data) {
					return err.response;
				}
				throw err;
			}
		},
		setReferralCodeData(context, status) {
			context.commit('SET_REFERRAL_CODE_DATA', status);
		},
	},
	mutations: {
		SET_REFERRAL_CODE_DATA(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(
				`referral_code_data_${clinicCode}`,
				JSON.stringify(data),
			);
		},
	},
	getters: {
		referralCodeDataByC: () => (clinicCode) => {
			const data = localStorage.getItem(`referral_code_data_${clinicCode}`);
			return data ? JSON.parse(data) : null;
		},
	},
};
